import React from 'react'
import PropTypes from 'prop-types'
import { CircularProgress } from '@mui/material'

import styles from './styles'

function LoadingSplash(props) {
  const { loadingText } = props
  const classes = styles()
  return (
    <div className={classes.loadingContainer}>
      <CircularProgress size={64} color="primary" />
      <span className={classes.loadingText}>
        {loadingText}
      </span>
    </div>
  )
}

LoadingSplash.propTypes = {
  loadingText: PropTypes.string.isRequired,
}

export default LoadingSplash
